/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   MessagingModal actions
 */

import type {
  Building,
  Listing,
  MessageModalDataEmpty,
  MessageModalDataNonEmpty,
  NormalListingData,
} from '@zcode/state-type'
import type { OptionalIfUndefined } from '@zcode/utility-types'
import { createAction } from 'redux-actions'
import type { DistributedPick } from 'type-fest'
import {
  CANCEL_FETCHING_ENTITY,
  DONE_FETCHING_ENTITY,
  ERROR_FETCHING_ENTITY,
  NEXT_STEP,
  PREVIOUS_STEP,
  RECEIVE_DATA,
  RECEIVE_ENTITY,
  START_FETCHING_ENTITY,
} from '../constants/messageModal'

export const startFetchingEntity = createAction<number, typeof START_FETCHING_ENTITY>(
  START_FETCHING_ENTITY
)
export const cancelFetchingEntity = createAction(CANCEL_FETCHING_ENTITY)
export const receiveEntity = createAction<
  Building | Listing<NormalListingData>,
  typeof RECEIVE_ENTITY
>(RECEIVE_ENTITY)
export const errorFetchingEntity = createAction<unknown, typeof ERROR_FETCHING_ENTITY>(
  ERROR_FETCHING_ENTITY
)
export const doneFetchingEntity = createAction(DONE_FETCHING_ENTITY)

type ReceivedMessageDataFields =
  | 'analyticChannel'
  | 'ctaName'
  | 'equalCTAIntent'
  | 'entity'
  | 'hasInstantTourAvailability'
  | 'isFilterAd'
  | 'onlyShowFloorplanGroup'
  | 'origin'
  | 'selectedFloorplan'
  | 'selectedUnit'
  | 'showAgentInfo'
  | 'viewingId'
  | 'viewingTime'
export type EmptyReceivedMessageData = OptionalIfUndefined<
  DistributedPick<MessageModalDataEmpty, ReceivedMessageDataFields> & { isMobile?: never }
>
export type NonEmptyReceivedMessageData = OptionalIfUndefined<
  DistributedPick<MessageModalDataNonEmpty, ReceivedMessageDataFields> & { isMobile?: boolean }
>
export type ReceivedMessageData =
  | EmptyReceivedMessageData
  | (NonEmptyReceivedMessageData & { showDatePicker?: boolean })
export const receiveData = createAction<ReceivedMessageData, typeof RECEIVE_DATA>(RECEIVE_DATA)

export const nextStep = createAction(NEXT_STEP)
export const previousStep = createAction(PREVIOUS_STEP)
